package com.eladfinish.bible.contest.screens.search.model

import com.eladfinish.bible.contest.domain.BooksRepository.bookNamesHebrew
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

/** One row of the "results by book" sheet: how many of the search results are in one book. */
data class BookResultsCount(
    val bookIndex: Int,
    val bookName: String,
    val resultsCount: Int,
)

/** In which books the results are, in the Bible's order. A result with no known book is left out. */
fun List<VerseUiModel>.countResultsByBook(): ImmutableList<BookResultsCount> =
    filter { it.bookIndex in bookNamesHebrew.indices }
        .groupingBy { it.bookIndex }
        .eachCount()
        .entries
        .sortedBy { it.key }
        .map { (bookIndex, count) ->
            BookResultsCount(
                bookIndex = bookIndex,
                bookName = bookNamesHebrew[bookIndex],
                resultsCount = count,
            )
        }
        .toImmutableList()

fun List<VerseUiModel>.countDifferentBooks(): Int =
    asSequence()
        .map { it.bookIndex }
        .filter { it in bookNamesHebrew.indices }
        .distinct()
        .count()

/**
 * A one-time request to show [index] of the results list at its top, then highlight it for a
 * moment. Cleared once the list has handled it, so it does not run again when the list returns.
 */
data class ResultsJump(
    val index: Int,
    val resultId: String,
)

/** The jump to the first result of [bookIndex], or null when no result is in that book. */
fun List<VerseUiModel>.jumpToFirstResultOf(bookIndex: Int): ResultsJump? {
    val index = indexOfFirst { it.bookIndex == bookIndex }
    if (index < 0) return null
    return ResultsJump(
        index = index,
        resultId = this[index].id,
    )
}
